import { render } from "./LwButton.vue?vue&type=template&id=6419fc2d&scoped=true"
import script from "./LwButton.vue?vue&type=script&lang=js"
export * from "./LwButton.vue?vue&type=script&lang=js"

import "./LwButton.vue?vue&type=style&index=0&id=6419fc2d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6419fc2d"]])

export default __exports__